export default {
  LOW: `LOW`,
  MEDIUM: `MEDIUM`,
  HIGH: `HIGH`,
};
